import { getSideBarItems } from "./duckSidebar";
import { getCollectionItems } from "./duckSidebarCollection";

const LOAD_MENUITEMS = "LOAD_MENUITEMS";
const LOAD_MENUITEMS_SUCCESS = "LOAD_MENUITEMS_SUCCESS";
const LOAD_MENUITEMS_FAIL = "LOAD_MENUITEMS_FAIL";

const SUBMIT = "SUBMIT";
const SUBMIT_SUCCESS = "SUBMIT_SUCCESS";
const SUBMIT_FAIL = "SUBMIT_FAIL";

export default function layout(
  state = {
    data: [],
    isLoading: true,
    hasErrored: false,
    message: "",
    isSubmitting: false,
  },
  action,
) {
  switch (action.type) {
    case LOAD_MENUITEMS: {
      return Object.assign({}, state, {
        isLoading: true,
        hasErrored: false,
      });
    }

    case LOAD_MENUITEMS_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        message: action.error.message,
        hasErrored: true,
      });
    }

    case LOAD_MENUITEMS_SUCCESS: {
      return Object.assign({}, state, {
        data: action.payload.data,
        isLoading: false,
        hasErrored: false,
      });
    }

    case SUBMIT: {
      return Object.assign({}, state, {
        isSubmitting: true,
      });
    }

    case SUBMIT_SUCCESS: {
      return Object.assign({}, state, {
        isSubmitting: false,
      });
    }

    case SUBMIT_FAIL: {
      return Object.assign({}, state, {
        isSubmitting: false,
        message: action.payload.message,
      });
    }
    default:
      return state;
  }
}

export function getMenuItems() {
  return {
    type: LOAD_MENUITEMS,
    payload: {
      request: {
        url: "MenuItem/",
      },
    },
  };
}

export function addOrEditMenuItem(menuItem) {
  return {
    type: SUBMIT,
    payload: {
      request: {
        url: "MenuItem",
        method: "POST",
        data: menuItem,
      },
      options: {
        onSuccess({ dispatch }) {
          // eslint-disable-next-line no-console
          console.log("Menu item added/edited, refreshing menu items");
          dispatch(getMenuItems());
          dispatch(getSideBarItems());
          dispatch(getCollectionItems());
        },
        onFail(_error) {
          // eslint-disable-next-line no-console
          console.error("Menu item add/edit failed", _error);
        },
      },
    },
  };
}

export function deleteMenuItem(id) {
  return {
    type: SUBMIT,
    payload: {
      request: {
        url: "MenuItem/" + id,
        method: "DELETE",
      },
      options: {
        onSuccess({ dispatch }) {
          dispatch(getMenuItems());
          dispatch(getSideBarItems());
          dispatch(getCollectionItems());
        },
      },
    },
  };
}
